module.exports = __webpack_public_path__ + "img/reorder.8a0bc98.png";